export default __webpack_public_path__ + "static/media/annecy-hightlited-3x.58fed8bf.webp";